// source: fitness-service/v1/trainer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var fitness$service_v1_client_pb = require('../../fitness-service/v1/client_pb.js');
goog.object.extend(proto, fitness$service_v1_client_pb);
var fitness$service_v1_common_pb = require('../../fitness-service/v1/common_pb.js');
goog.object.extend(proto, fitness$service_v1_common_pb);
var fitness$service_v1_workout_pb = require('../../fitness-service/v1/workout_pb.js');
goog.object.extend(proto, fitness$service_v1_workout_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.fitness.service.v1.AddClientToGroupRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.AddClientToGroupResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.AssignWorkoutToGroupRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.AssignWorkoutToGroupResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateGroupRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateGroupResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateGroupWorkoutPlanRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateGroupWorkoutPlanResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteGroupRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteGroupResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupDetailsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupDetailsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupMembershipHistoryRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupMembershipHistoryResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupWorkoutsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupWorkoutsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetMyClientsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetMyClientsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetMyGroupsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetMyGroupsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetMyProfileRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetMyProfileResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GroupMember', null, global);
goog.exportSymbol('proto.fitness.service.v1.GroupMembershipRecord', null, global);
goog.exportSymbol('proto.fitness.service.v1.GroupWorkout', null, global);
goog.exportSymbol('proto.fitness.service.v1.MoveClientBetweenGroupsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.MoveClientBetweenGroupsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.RemoveClientFromGroupRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.RemoveClientFromGroupResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.RemoveWorkoutFromGroupRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.RemoveWorkoutFromGroupResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.ScheduleConflict', null, global);
goog.exportSymbol('proto.fitness.service.v1.TrainerGroup', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateGroupRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateGroupResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateMyProfileRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateMyProfileResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetMyClientsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetMyClientsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetMyClientsRequest.displayName = 'proto.fitness.service.v1.GetMyClientsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetMyClientsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetMyClientsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetMyClientsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetMyClientsResponse.displayName = 'proto.fitness.service.v1.GetMyClientsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetMyProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetMyProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetMyProfileRequest.displayName = 'proto.fitness.service.v1.GetMyProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetMyProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetMyProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetMyProfileResponse.displayName = 'proto.fitness.service.v1.GetMyProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateMyProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateMyProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateMyProfileRequest.displayName = 'proto.fitness.service.v1.UpdateMyProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateMyProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateMyProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateMyProfileResponse.displayName = 'proto.fitness.service.v1.UpdateMyProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.TrainerGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.TrainerGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.TrainerGroup.displayName = 'proto.fitness.service.v1.TrainerGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GroupMember = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GroupMember, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GroupMember.displayName = 'proto.fitness.service.v1.GroupMember';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GroupWorkout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GroupWorkout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GroupWorkout.displayName = 'proto.fitness.service.v1.GroupWorkout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateGroupRequest.displayName = 'proto.fitness.service.v1.CreateGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateGroupResponse.displayName = 'proto.fitness.service.v1.CreateGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetMyGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetMyGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetMyGroupsRequest.displayName = 'proto.fitness.service.v1.GetMyGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetMyGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetMyGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetMyGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetMyGroupsResponse.displayName = 'proto.fitness.service.v1.GetMyGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupDetailsRequest.displayName = 'proto.fitness.service.v1.GetGroupDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetGroupDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupDetailsResponse.displayName = 'proto.fitness.service.v1.GetGroupDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateGroupRequest.displayName = 'proto.fitness.service.v1.UpdateGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateGroupResponse.displayName = 'proto.fitness.service.v1.UpdateGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteGroupRequest.displayName = 'proto.fitness.service.v1.DeleteGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteGroupResponse.displayName = 'proto.fitness.service.v1.DeleteGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AddClientToGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AddClientToGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AddClientToGroupRequest.displayName = 'proto.fitness.service.v1.AddClientToGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AddClientToGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AddClientToGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AddClientToGroupResponse.displayName = 'proto.fitness.service.v1.AddClientToGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.RemoveClientFromGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.RemoveClientFromGroupRequest.displayName = 'proto.fitness.service.v1.RemoveClientFromGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.RemoveClientFromGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.RemoveClientFromGroupResponse.displayName = 'proto.fitness.service.v1.RemoveClientFromGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.MoveClientBetweenGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.MoveClientBetweenGroupsRequest.displayName = 'proto.fitness.service.v1.MoveClientBetweenGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.MoveClientBetweenGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.MoveClientBetweenGroupsResponse.displayName = 'proto.fitness.service.v1.MoveClientBetweenGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.CreateGroupWorkoutPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.displayName = 'proto.fitness.service.v1.CreateGroupWorkoutPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.CreateGroupWorkoutPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.displayName = 'proto.fitness.service.v1.CreateGroupWorkoutPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ScheduleConflict = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.ScheduleConflict.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.ScheduleConflict, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ScheduleConflict.displayName = 'proto.fitness.service.v1.ScheduleConflict';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.AssignWorkoutToGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AssignWorkoutToGroupRequest.displayName = 'proto.fitness.service.v1.AssignWorkoutToGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.AssignWorkoutToGroupResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.AssignWorkoutToGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.AssignWorkoutToGroupResponse.displayName = 'proto.fitness.service.v1.AssignWorkoutToGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupWorkoutsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupWorkoutsRequest.displayName = 'proto.fitness.service.v1.GetGroupWorkoutsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetGroupWorkoutsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupWorkoutsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupWorkoutsResponse.displayName = 'proto.fitness.service.v1.GetGroupWorkoutsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.RemoveWorkoutFromGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.displayName = 'proto.fitness.service.v1.RemoveWorkoutFromGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.RemoveWorkoutFromGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.displayName = 'proto.fitness.service.v1.RemoveWorkoutFromGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.displayName = 'proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.displayName = 'proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.displayName = 'proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.displayName = 'proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupMembershipHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupMembershipHistoryRequest.displayName = 'proto.fitness.service.v1.GetGroupMembershipHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetGroupMembershipHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupMembershipHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupMembershipHistoryResponse.displayName = 'proto.fitness.service.v1.GetGroupMembershipHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GroupMembershipRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GroupMembershipRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GroupMembershipRecord.displayName = 'proto.fitness.service.v1.GroupMembershipRecord';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetMyClientsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetMyClientsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyClientsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetMyClientsRequest}
 */
proto.fitness.service.v1.GetMyClientsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetMyClientsRequest;
  return proto.fitness.service.v1.GetMyClientsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetMyClientsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetMyClientsRequest}
 */
proto.fitness.service.v1.GetMyClientsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetMyClientsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetMyClientsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyClientsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyClientsRequest} returns this
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyClientsRequest} returns this
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool active_only = 3;
 * @return {boolean}
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetMyClientsRequest} returns this
 */
proto.fitness.service.v1.GetMyClientsRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetMyClientsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetMyClientsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetMyClientsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyClientsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
clientRelationsList: jspb.Message.toObjectList(msg.getClientRelationsList(),
    fitness$service_v1_common_pb.TrainerClientRelation.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
message: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetMyClientsResponse}
 */
proto.fitness.service.v1.GetMyClientsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetMyClientsResponse;
  return proto.fitness.service.v1.GetMyClientsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetMyClientsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetMyClientsResponse}
 */
proto.fitness.service.v1.GetMyClientsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fitness$service_v1_common_pb.TrainerClientRelation;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerClientRelation.deserializeBinaryFromReader);
      msg.addClientRelations(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetMyClientsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetMyClientsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyClientsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientRelationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      fitness$service_v1_common_pb.TrainerClientRelation.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated TrainerClientRelation client_relations = 1;
 * @return {!Array<!proto.fitness.service.v1.TrainerClientRelation>}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.getClientRelationsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.TrainerClientRelation>} */ (
    jspb.Message.getRepeatedWrapperField(this, fitness$service_v1_common_pb.TrainerClientRelation, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.TrainerClientRelation>} value
 * @return {!proto.fitness.service.v1.GetMyClientsResponse} returns this
*/
proto.fitness.service.v1.GetMyClientsResponse.prototype.setClientRelationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.TrainerClientRelation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.TrainerClientRelation}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.addClientRelations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.TrainerClientRelation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetMyClientsResponse} returns this
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.clearClientRelationsList = function() {
  return this.setClientRelationsList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyClientsResponse} returns this
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyClientsResponse} returns this
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyClientsResponse} returns this
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetMyClientsResponse} returns this
 */
proto.fitness.service.v1.GetMyClientsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetMyProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetMyProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetMyProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetMyProfileRequest}
 */
proto.fitness.service.v1.GetMyProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetMyProfileRequest;
  return proto.fitness.service.v1.GetMyProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetMyProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetMyProfileRequest}
 */
proto.fitness.service.v1.GetMyProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetMyProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetMyProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetMyProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetMyProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetMyProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetMyProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
profile: (f = msg.getProfile()) && fitness$service_v1_common_pb.TrainerProfile.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetMyProfileResponse}
 */
proto.fitness.service.v1.GetMyProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetMyProfileResponse;
  return proto.fitness.service.v1.GetMyProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetMyProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetMyProfileResponse}
 */
proto.fitness.service.v1.GetMyProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fitness$service_v1_common_pb.TrainerProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerProfile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetMyProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetMyProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetMyProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fitness$service_v1_common_pb.TrainerProfile.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TrainerProfile profile = 1;
 * @return {?proto.fitness.service.v1.TrainerProfile}
 */
proto.fitness.service.v1.GetMyProfileResponse.prototype.getProfile = function() {
  return /** @type{?proto.fitness.service.v1.TrainerProfile} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_common_pb.TrainerProfile, 1));
};


/**
 * @param {?proto.fitness.service.v1.TrainerProfile|undefined} value
 * @return {!proto.fitness.service.v1.GetMyProfileResponse} returns this
*/
proto.fitness.service.v1.GetMyProfileResponse.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetMyProfileResponse} returns this
 */
proto.fitness.service.v1.GetMyProfileResponse.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetMyProfileResponse.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.GetMyProfileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetMyProfileResponse} returns this
 */
proto.fitness.service.v1.GetMyProfileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateMyProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateMyProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateMyProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
specialization: jspb.Message.getFieldWithDefault(msg, 1, ""),
certification: jspb.Message.getFieldWithDefault(msg, 2, ""),
experienceYears: jspb.Message.getFieldWithDefault(msg, 3, 0),
instagramHandle: jspb.Message.getFieldWithDefault(msg, 4, ""),
phone: jspb.Message.getFieldWithDefault(msg, 5, ""),
name: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateMyProfileRequest;
  return proto.fitness.service.v1.UpdateMyProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateMyProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSpecialization(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCertification(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExperienceYears(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setInstagramHandle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateMyProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateMyProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateMyProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpecialization();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCertification();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExperienceYears();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getInstagramHandle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string specialization = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.getSpecialization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.setSpecialization = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string certification = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.getCertification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.setCertification = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 experience_years = 3;
 * @return {number}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.getExperienceYears = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.setExperienceYears = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string instagram_handle = 4;
 * @return {string}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.getInstagramHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.setInstagramHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string phone = 5;
 * @return {string}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileRequest} returns this
 */
proto.fitness.service.v1.UpdateMyProfileRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateMyProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateMyProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateMyProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
profile: (f = msg.getProfile()) && fitness$service_v1_common_pb.TrainerProfile.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateMyProfileResponse}
 */
proto.fitness.service.v1.UpdateMyProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateMyProfileResponse;
  return proto.fitness.service.v1.UpdateMyProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateMyProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateMyProfileResponse}
 */
proto.fitness.service.v1.UpdateMyProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fitness$service_v1_common_pb.TrainerProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.TrainerProfile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateMyProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateMyProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateMyProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fitness$service_v1_common_pb.TrainerProfile.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TrainerProfile profile = 1;
 * @return {?proto.fitness.service.v1.TrainerProfile}
 */
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.getProfile = function() {
  return /** @type{?proto.fitness.service.v1.TrainerProfile} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_common_pb.TrainerProfile, 1));
};


/**
 * @param {?proto.fitness.service.v1.TrainerProfile|undefined} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileResponse} returns this
*/
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateMyProfileResponse} returns this
 */
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateMyProfileResponse} returns this
 */
proto.fitness.service.v1.UpdateMyProfileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.TrainerGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.TrainerGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.TrainerGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
trainerId: jspb.Message.getFieldWithDefault(msg, 4, ""),
color: jspb.Message.getFieldWithDefault(msg, 5, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
maxMembers: jspb.Message.getFieldWithDefault(msg, 7, 0),
currentMemberCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, ""),
updatedAt: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.TrainerGroup}
 */
proto.fitness.service.v1.TrainerGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.TrainerGroup;
  return proto.fitness.service.v1.TrainerGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.TrainerGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.TrainerGroup}
 */
proto.fitness.service.v1.TrainerGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxMembers(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentMemberCount(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.TrainerGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.TrainerGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.TrainerGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.TrainerGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMaxMembers();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCurrentMemberCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string trainer_id = 4;
 * @return {string}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string color = 5;
 * @return {string}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_active = 6;
 * @return {boolean}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 max_members = 7;
 * @return {number}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getMaxMembers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setMaxMembers = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 current_member_count = 8;
 * @return {number}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getCurrentMemberCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setCurrentMemberCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string created_at = 9;
 * @return {string}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string updated_at = 10;
 * @return {string}
 */
proto.fitness.service.v1.TrainerGroup.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.TrainerGroup} returns this
 */
proto.fitness.service.v1.TrainerGroup.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GroupMember.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GroupMember.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GroupMember} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GroupMember.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
client: (f = msg.getClient()) && fitness$service_v1_common_pb.ClientProfile.toObject(includeInstance, f),
joinDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
leaveDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
notes: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GroupMember}
 */
proto.fitness.service.v1.GroupMember.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GroupMember;
  return proto.fitness.service.v1.GroupMember.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GroupMember} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GroupMember}
 */
proto.fitness.service.v1.GroupMember.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 3:
      var value = new fitness$service_v1_common_pb.ClientProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.ClientProfile.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setJoinDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLeaveDate(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GroupMember.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GroupMember.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GroupMember} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GroupMember.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fitness$service_v1_common_pb.ClientProfile.serializeBinaryToWriter
    );
  }
  f = message.getJoinDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLeaveDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GroupMember.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMember} returns this
 */
proto.fitness.service.v1.GroupMember.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.GroupMember.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMember} returns this
 */
proto.fitness.service.v1.GroupMember.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ClientProfile client = 3;
 * @return {?proto.fitness.service.v1.ClientProfile}
 */
proto.fitness.service.v1.GroupMember.prototype.getClient = function() {
  return /** @type{?proto.fitness.service.v1.ClientProfile} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_common_pb.ClientProfile, 3));
};


/**
 * @param {?proto.fitness.service.v1.ClientProfile|undefined} value
 * @return {!proto.fitness.service.v1.GroupMember} returns this
*/
proto.fitness.service.v1.GroupMember.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GroupMember} returns this
 */
proto.fitness.service.v1.GroupMember.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GroupMember.prototype.hasClient = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string join_date = 4;
 * @return {string}
 */
proto.fitness.service.v1.GroupMember.prototype.getJoinDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMember} returns this
 */
proto.fitness.service.v1.GroupMember.prototype.setJoinDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string leave_date = 5;
 * @return {string}
 */
proto.fitness.service.v1.GroupMember.prototype.getLeaveDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMember} returns this
 */
proto.fitness.service.v1.GroupMember.prototype.setLeaveDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_active = 6;
 * @return {boolean}
 */
proto.fitness.service.v1.GroupMember.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GroupMember} returns this
 */
proto.fitness.service.v1.GroupMember.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.fitness.service.v1.GroupMember.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMember} returns this
 */
proto.fitness.service.v1.GroupMember.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GroupWorkout.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GroupWorkout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GroupWorkout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GroupWorkout.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 3, ""),
workoutPlanTitle: jspb.Message.getFieldWithDefault(msg, 4, ""),
assignedDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
startDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
endDate: jspb.Message.getFieldWithDefault(msg, 7, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
notes: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GroupWorkout}
 */
proto.fitness.service.v1.GroupWorkout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GroupWorkout;
  return proto.fitness.service.v1.GroupWorkout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GroupWorkout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GroupWorkout}
 */
proto.fitness.service.v1.GroupWorkout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAssignedDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStartDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEndDate(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GroupWorkout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GroupWorkout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GroupWorkout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GroupWorkout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWorkoutPlanTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssignedDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string workout_plan_id = 3;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string workout_plan_title = 4;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getWorkoutPlanTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setWorkoutPlanTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string assigned_date = 5;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getAssignedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setAssignedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string start_date = 6;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string end_date = 7;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_active = 8;
 * @return {boolean}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string notes = 9;
 * @return {string}
 */
proto.fitness.service.v1.GroupWorkout.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupWorkout} returns this
 */
proto.fitness.service.v1.GroupWorkout.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, ""),
maxMembers: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateGroupRequest}
 */
proto.fitness.service.v1.CreateGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateGroupRequest;
  return proto.fitness.service.v1.CreateGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateGroupRequest}
 */
proto.fitness.service.v1.CreateGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMaxMembers();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupRequest} returns this
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupRequest} returns this
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupRequest} returns this
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 max_members = 4;
 * @return {number}
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.getMaxMembers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateGroupRequest} returns this
 */
proto.fitness.service.v1.CreateGroupRequest.prototype.setMaxMembers = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
group: (f = msg.getGroup()) && proto.fitness.service.v1.TrainerGroup.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateGroupResponse}
 */
proto.fitness.service.v1.CreateGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateGroupResponse;
  return proto.fitness.service.v1.CreateGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateGroupResponse}
 */
proto.fitness.service.v1.CreateGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.TrainerGroup;
      reader.readMessage(value,proto.fitness.service.v1.TrainerGroup.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.TrainerGroup.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TrainerGroup group = 1;
 * @return {?proto.fitness.service.v1.TrainerGroup}
 */
proto.fitness.service.v1.CreateGroupResponse.prototype.getGroup = function() {
  return /** @type{?proto.fitness.service.v1.TrainerGroup} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.TrainerGroup, 1));
};


/**
 * @param {?proto.fitness.service.v1.TrainerGroup|undefined} value
 * @return {!proto.fitness.service.v1.CreateGroupResponse} returns this
*/
proto.fitness.service.v1.CreateGroupResponse.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateGroupResponse} returns this
 */
proto.fitness.service.v1.CreateGroupResponse.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateGroupResponse.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupResponse} returns this
 */
proto.fitness.service.v1.CreateGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetMyGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetMyGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetMyGroupsRequest}
 */
proto.fitness.service.v1.GetMyGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetMyGroupsRequest;
  return proto.fitness.service.v1.GetMyGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetMyGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetMyGroupsRequest}
 */
proto.fitness.service.v1.GetMyGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetMyGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetMyGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyGroupsRequest} returns this
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyGroupsRequest} returns this
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool active_only = 3;
 * @return {boolean}
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetMyGroupsRequest} returns this
 */
proto.fitness.service.v1.GetMyGroupsRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetMyGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetMyGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetMyGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.fitness.service.v1.TrainerGroup.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
message: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse}
 */
proto.fitness.service.v1.GetMyGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetMyGroupsResponse;
  return proto.fitness.service.v1.GetMyGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetMyGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse}
 */
proto.fitness.service.v1.GetMyGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.TrainerGroup;
      reader.readMessage(value,proto.fitness.service.v1.TrainerGroup.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetMyGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetMyGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetMyGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.TrainerGroup.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated TrainerGroup groups = 1;
 * @return {!Array<!proto.fitness.service.v1.TrainerGroup>}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.TrainerGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.TrainerGroup, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.TrainerGroup>} value
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse} returns this
*/
proto.fitness.service.v1.GetMyGroupsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.TrainerGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.TrainerGroup}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.TrainerGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse} returns this
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse} returns this
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse} returns this
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse} returns this
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetMyGroupsResponse} returns this
 */
proto.fitness.service.v1.GetMyGroupsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupDetailsRequest}
 */
proto.fitness.service.v1.GetGroupDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupDetailsRequest;
  return proto.fitness.service.v1.GetGroupDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupDetailsRequest}
 */
proto.fitness.service.v1.GetGroupDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupDetailsRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupDetailsRequest} returns this
 */
proto.fitness.service.v1.GetGroupDetailsRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetGroupDetailsResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
group: (f = msg.getGroup()) && proto.fitness.service.v1.TrainerGroup.toObject(includeInstance, f),
membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.fitness.service.v1.GroupMember.toObject, includeInstance),
workoutsList: jspb.Message.toObjectList(msg.getWorkoutsList(),
    proto.fitness.service.v1.GroupWorkout.toObject, includeInstance),
message: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupDetailsResponse;
  return proto.fitness.service.v1.GetGroupDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.TrainerGroup;
      reader.readMessage(value,proto.fitness.service.v1.TrainerGroup.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.GroupMember;
      reader.readMessage(value,proto.fitness.service.v1.GroupMember.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 3:
      var value = new proto.fitness.service.v1.GroupWorkout;
      reader.readMessage(value,proto.fitness.service.v1.GroupWorkout.deserializeBinaryFromReader);
      msg.addWorkouts(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.TrainerGroup.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fitness.service.v1.GroupMember.serializeBinaryToWriter
    );
  }
  f = message.getWorkoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fitness.service.v1.GroupWorkout.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional TrainerGroup group = 1;
 * @return {?proto.fitness.service.v1.TrainerGroup}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.getGroup = function() {
  return /** @type{?proto.fitness.service.v1.TrainerGroup} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.TrainerGroup, 1));
};


/**
 * @param {?proto.fitness.service.v1.TrainerGroup|undefined} value
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse} returns this
*/
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse} returns this
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated GroupMember members = 2;
 * @return {!Array<!proto.fitness.service.v1.GroupMember>}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.GroupMember>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.GroupMember, 2));
};


/**
 * @param {!Array<!proto.fitness.service.v1.GroupMember>} value
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse} returns this
*/
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fitness.service.v1.GroupMember=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.GroupMember}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fitness.service.v1.GroupMember, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse} returns this
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * repeated GroupWorkout workouts = 3;
 * @return {!Array<!proto.fitness.service.v1.GroupWorkout>}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.getWorkoutsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.GroupWorkout>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.GroupWorkout, 3));
};


/**
 * @param {!Array<!proto.fitness.service.v1.GroupWorkout>} value
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse} returns this
*/
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.setWorkoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fitness.service.v1.GroupWorkout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.GroupWorkout}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.addWorkouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fitness.service.v1.GroupWorkout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse} returns this
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.clearWorkoutsList = function() {
  return this.setWorkoutsList([]);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupDetailsResponse} returns this
 */
proto.fitness.service.v1.GetGroupDetailsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
color: jspb.Message.getFieldWithDefault(msg, 4, ""),
maxMembers: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateGroupRequest}
 */
proto.fitness.service.v1.UpdateGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateGroupRequest;
  return proto.fitness.service.v1.UpdateGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateGroupRequest}
 */
proto.fitness.service.v1.UpdateGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setColor(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMaxMembers();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string color = 4;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 max_members = 5;
 * @return {number}
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.getMaxMembers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateGroupRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupRequest.prototype.setMaxMembers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
group: (f = msg.getGroup()) && proto.fitness.service.v1.TrainerGroup.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateGroupResponse}
 */
proto.fitness.service.v1.UpdateGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateGroupResponse;
  return proto.fitness.service.v1.UpdateGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateGroupResponse}
 */
proto.fitness.service.v1.UpdateGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.TrainerGroup;
      reader.readMessage(value,proto.fitness.service.v1.TrainerGroup.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.TrainerGroup.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TrainerGroup group = 1;
 * @return {?proto.fitness.service.v1.TrainerGroup}
 */
proto.fitness.service.v1.UpdateGroupResponse.prototype.getGroup = function() {
  return /** @type{?proto.fitness.service.v1.TrainerGroup} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.TrainerGroup, 1));
};


/**
 * @param {?proto.fitness.service.v1.TrainerGroup|undefined} value
 * @return {!proto.fitness.service.v1.UpdateGroupResponse} returns this
*/
proto.fitness.service.v1.UpdateGroupResponse.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateGroupResponse} returns this
 */
proto.fitness.service.v1.UpdateGroupResponse.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateGroupResponse.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupResponse} returns this
 */
proto.fitness.service.v1.UpdateGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteGroupRequest}
 */
proto.fitness.service.v1.DeleteGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteGroupRequest;
  return proto.fitness.service.v1.DeleteGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteGroupRequest}
 */
proto.fitness.service.v1.DeleteGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteGroupRequest} returns this
 */
proto.fitness.service.v1.DeleteGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteGroupResponse}
 */
proto.fitness.service.v1.DeleteGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteGroupResponse;
  return proto.fitness.service.v1.DeleteGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteGroupResponse}
 */
proto.fitness.service.v1.DeleteGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteGroupResponse} returns this
 */
proto.fitness.service.v1.DeleteGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AddClientToGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AddClientToGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AddClientToGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 2, ""),
notes: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AddClientToGroupRequest}
 */
proto.fitness.service.v1.AddClientToGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AddClientToGroupRequest;
  return proto.fitness.service.v1.AddClientToGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AddClientToGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AddClientToGroupRequest}
 */
proto.fitness.service.v1.AddClientToGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AddClientToGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AddClientToGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AddClientToGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AddClientToGroupRequest} returns this
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AddClientToGroupRequest} returns this
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string notes = 3;
 * @return {string}
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AddClientToGroupRequest} returns this
 */
proto.fitness.service.v1.AddClientToGroupRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AddClientToGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AddClientToGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AddClientToGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AddClientToGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
member: (f = msg.getMember()) && proto.fitness.service.v1.GroupMember.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AddClientToGroupResponse}
 */
proto.fitness.service.v1.AddClientToGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AddClientToGroupResponse;
  return proto.fitness.service.v1.AddClientToGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AddClientToGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AddClientToGroupResponse}
 */
proto.fitness.service.v1.AddClientToGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.GroupMember;
      reader.readMessage(value,proto.fitness.service.v1.GroupMember.deserializeBinaryFromReader);
      msg.setMember(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AddClientToGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AddClientToGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AddClientToGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AddClientToGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMember();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.GroupMember.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional GroupMember member = 1;
 * @return {?proto.fitness.service.v1.GroupMember}
 */
proto.fitness.service.v1.AddClientToGroupResponse.prototype.getMember = function() {
  return /** @type{?proto.fitness.service.v1.GroupMember} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.GroupMember, 1));
};


/**
 * @param {?proto.fitness.service.v1.GroupMember|undefined} value
 * @return {!proto.fitness.service.v1.AddClientToGroupResponse} returns this
*/
proto.fitness.service.v1.AddClientToGroupResponse.prototype.setMember = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AddClientToGroupResponse} returns this
 */
proto.fitness.service.v1.AddClientToGroupResponse.prototype.clearMember = function() {
  return this.setMember(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AddClientToGroupResponse.prototype.hasMember = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.AddClientToGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AddClientToGroupResponse} returns this
 */
proto.fitness.service.v1.AddClientToGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.RemoveClientFromGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.RemoveClientFromGroupRequest}
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.RemoveClientFromGroupRequest;
  return proto.fitness.service.v1.RemoveClientFromGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.RemoveClientFromGroupRequest}
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.RemoveClientFromGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.RemoveClientFromGroupRequest} returns this
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.RemoveClientFromGroupRequest} returns this
 */
proto.fitness.service.v1.RemoveClientFromGroupRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.RemoveClientFromGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.RemoveClientFromGroupResponse}
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.RemoveClientFromGroupResponse;
  return proto.fitness.service.v1.RemoveClientFromGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.RemoveClientFromGroupResponse}
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.RemoveClientFromGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.RemoveClientFromGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.RemoveClientFromGroupResponse} returns this
 */
proto.fitness.service.v1.RemoveClientFromGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.MoveClientBetweenGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fromGroupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
toGroupId: jspb.Message.getFieldWithDefault(msg, 3, ""),
notes: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.MoveClientBetweenGroupsRequest;
  return proto.fitness.service.v1.MoveClientBetweenGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFromGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setToGroupId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.MoveClientBetweenGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFromGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getToGroupId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string client_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} returns this
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string from_group_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.getFromGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} returns this
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.setFromGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string to_group_id = 3;
 * @return {string}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.getToGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} returns this
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.setToGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string notes = 4;
 * @return {string}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsRequest} returns this
 */
proto.fitness.service.v1.MoveClientBetweenGroupsRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.MoveClientBetweenGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
newMember: (f = msg.getNewMember()) && proto.fitness.service.v1.GroupMember.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.MoveClientBetweenGroupsResponse;
  return proto.fitness.service.v1.MoveClientBetweenGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.GroupMember;
      reader.readMessage(value,proto.fitness.service.v1.GroupMember.deserializeBinaryFromReader);
      msg.setNewMember(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.MoveClientBetweenGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewMember();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.GroupMember.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional GroupMember new_member = 1;
 * @return {?proto.fitness.service.v1.GroupMember}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.getNewMember = function() {
  return /** @type{?proto.fitness.service.v1.GroupMember} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.GroupMember, 1));
};


/**
 * @param {?proto.fitness.service.v1.GroupMember|undefined} value
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse} returns this
*/
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.setNewMember = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse} returns this
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.clearNewMember = function() {
  return this.setNewMember(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.hasNewMember = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.MoveClientBetweenGroupsResponse} returns this
 */
proto.fitness.service.v1.MoveClientBetweenGroupsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
goals: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
difficulty: jspb.Message.getFieldWithDefault(msg, 7, ""),
planType: jspb.Message.getFieldWithDefault(msg, 8, ""),
dailyWorkoutsList: jspb.Message.toObjectList(msg.getDailyWorkoutsList(),
    fitness$service_v1_workout_pb.CreateDailyWorkout.toObject, includeInstance),
sourceTemplateId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateGroupWorkoutPlanRequest;
  return proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGoals(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDifficulty(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPlanType(value);
      break;
    case 9:
      var value = new fitness$service_v1_workout_pb.CreateDailyWorkout;
      reader.readMessage(value,fitness$service_v1_workout_pb.CreateDailyWorkout.deserializeBinaryFromReader);
      msg.addDailyWorkouts(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSourceTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getGoals();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDifficulty();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPlanType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDailyWorkoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      fitness$service_v1_workout_pb.CreateDailyWorkout.serializeBinaryToWriter
    );
  }
  f = message.getSourceTemplateId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string goals = 5;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getGoals = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setGoals = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string difficulty = 7;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getDifficulty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string plan_type = 8;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getPlanType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setPlanType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated CreateDailyWorkout daily_workouts = 9;
 * @return {!Array<!proto.fitness.service.v1.CreateDailyWorkout>}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getDailyWorkoutsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.CreateDailyWorkout>} */ (
    jspb.Message.getRepeatedWrapperField(this, fitness$service_v1_workout_pb.CreateDailyWorkout, 9));
};


/**
 * @param {!Array<!proto.fitness.service.v1.CreateDailyWorkout>} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setDailyWorkoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.fitness.service.v1.CreateDailyWorkout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.CreateDailyWorkout}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.addDailyWorkouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.fitness.service.v1.CreateDailyWorkout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.clearDailyWorkoutsList = function() {
  return this.setDailyWorkoutsList([]);
};


/**
 * optional string source_template_id = 10;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.getSourceTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanRequest.prototype.setSourceTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutPlan: (f = msg.getWorkoutPlan()) && fitness$service_v1_workout_pb.WorkoutPlan.toObject(includeInstance, f),
groupWorkout: (f = msg.getGroupWorkout()) && proto.fitness.service.v1.GroupWorkout.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 3, ""),
conflictsList: jspb.Message.toObjectList(msg.getConflictsList(),
    proto.fitness.service.v1.ScheduleConflict.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateGroupWorkoutPlanResponse;
  return proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fitness$service_v1_workout_pb.WorkoutPlan;
      reader.readMessage(value,fitness$service_v1_workout_pb.WorkoutPlan.deserializeBinaryFromReader);
      msg.setWorkoutPlan(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.GroupWorkout;
      reader.readMessage(value,proto.fitness.service.v1.GroupWorkout.deserializeBinaryFromReader);
      msg.setGroupWorkout(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.fitness.service.v1.ScheduleConflict;
      reader.readMessage(value,proto.fitness.service.v1.ScheduleConflict.deserializeBinaryFromReader);
      msg.addConflicts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutPlan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fitness$service_v1_workout_pb.WorkoutPlan.serializeBinaryToWriter
    );
  }
  f = message.getGroupWorkout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fitness.service.v1.GroupWorkout.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getConflictsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.fitness.service.v1.ScheduleConflict.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkoutPlan workout_plan = 1;
 * @return {?proto.fitness.service.v1.WorkoutPlan}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.getWorkoutPlan = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutPlan} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_workout_pb.WorkoutPlan, 1));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutPlan|undefined} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} returns this
*/
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.setWorkoutPlan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.clearWorkoutPlan = function() {
  return this.setWorkoutPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.hasWorkoutPlan = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional GroupWorkout group_workout = 2;
 * @return {?proto.fitness.service.v1.GroupWorkout}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.getGroupWorkout = function() {
  return /** @type{?proto.fitness.service.v1.GroupWorkout} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.GroupWorkout, 2));
};


/**
 * @param {?proto.fitness.service.v1.GroupWorkout|undefined} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} returns this
*/
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.setGroupWorkout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.clearGroupWorkout = function() {
  return this.setGroupWorkout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.hasGroupWorkout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ScheduleConflict conflicts = 4;
 * @return {!Array<!proto.fitness.service.v1.ScheduleConflict>}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.getConflictsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.ScheduleConflict>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.ScheduleConflict, 4));
};


/**
 * @param {!Array<!proto.fitness.service.v1.ScheduleConflict>} value
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} returns this
*/
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.setConflictsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.fitness.service.v1.ScheduleConflict=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ScheduleConflict}
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.addConflicts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.fitness.service.v1.ScheduleConflict, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.CreateGroupWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.CreateGroupWorkoutPlanResponse.prototype.clearConflictsList = function() {
  return this.setConflictsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.ScheduleConflict.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ScheduleConflict.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ScheduleConflict.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ScheduleConflict} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ScheduleConflict.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientName: jspb.Message.getFieldWithDefault(msg, 2, ""),
datesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ScheduleConflict}
 */
proto.fitness.service.v1.ScheduleConflict.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ScheduleConflict;
  return proto.fitness.service.v1.ScheduleConflict.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ScheduleConflict} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ScheduleConflict}
 */
proto.fitness.service.v1.ScheduleConflict.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addDates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ScheduleConflict.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ScheduleConflict.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ScheduleConflict} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ScheduleConflict.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string client_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.ScheduleConflict.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ScheduleConflict} returns this
 */
proto.fitness.service.v1.ScheduleConflict.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_name = 2;
 * @return {string}
 */
proto.fitness.service.v1.ScheduleConflict.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ScheduleConflict} returns this
 */
proto.fitness.service.v1.ScheduleConflict.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string dates = 3;
 * @return {!Array<string>}
 */
proto.fitness.service.v1.ScheduleConflict.prototype.getDatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fitness.service.v1.ScheduleConflict} returns this
 */
proto.fitness.service.v1.ScheduleConflict.prototype.setDatesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ScheduleConflict} returns this
 */
proto.fitness.service.v1.ScheduleConflict.prototype.addDates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.ScheduleConflict} returns this
 */
proto.fitness.service.v1.ScheduleConflict.prototype.clearDatesList = function() {
  return this.setDatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AssignWorkoutToGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 2, ""),
startDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
endDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
notes: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupRequest}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AssignWorkoutToGroupRequest;
  return proto.fitness.service.v1.AssignWorkoutToGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupRequest}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStartDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEndDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AssignWorkoutToGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workout_plan_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string start_date = 3;
 * @return {string}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string end_date = 4;
 * @return {string}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string notes = 5;
 * @return {string}
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupRequest} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.AssignWorkoutToGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
groupWorkout: (f = msg.getGroupWorkout()) && proto.fitness.service.v1.GroupWorkout.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
conflictsList: jspb.Message.toObjectList(msg.getConflictsList(),
    proto.fitness.service.v1.ScheduleConflict.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupResponse}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.AssignWorkoutToGroupResponse;
  return proto.fitness.service.v1.AssignWorkoutToGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupResponse}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.GroupWorkout;
      reader.readMessage(value,proto.fitness.service.v1.GroupWorkout.deserializeBinaryFromReader);
      msg.setGroupWorkout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.fitness.service.v1.ScheduleConflict;
      reader.readMessage(value,proto.fitness.service.v1.ScheduleConflict.deserializeBinaryFromReader);
      msg.addConflicts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.AssignWorkoutToGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupWorkout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.GroupWorkout.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConflictsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fitness.service.v1.ScheduleConflict.serializeBinaryToWriter
    );
  }
};


/**
 * optional GroupWorkout group_workout = 1;
 * @return {?proto.fitness.service.v1.GroupWorkout}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.getGroupWorkout = function() {
  return /** @type{?proto.fitness.service.v1.GroupWorkout} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.GroupWorkout, 1));
};


/**
 * @param {?proto.fitness.service.v1.GroupWorkout|undefined} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} returns this
*/
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.setGroupWorkout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.clearGroupWorkout = function() {
  return this.setGroupWorkout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.hasGroupWorkout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ScheduleConflict conflicts = 3;
 * @return {!Array<!proto.fitness.service.v1.ScheduleConflict>}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.getConflictsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.ScheduleConflict>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.ScheduleConflict, 3));
};


/**
 * @param {!Array<!proto.fitness.service.v1.ScheduleConflict>} value
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} returns this
*/
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.setConflictsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fitness.service.v1.ScheduleConflict=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ScheduleConflict}
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.addConflicts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fitness.service.v1.ScheduleConflict, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.AssignWorkoutToGroupResponse} returns this
 */
proto.fitness.service.v1.AssignWorkoutToGroupResponse.prototype.clearConflictsList = function() {
  return this.setConflictsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupWorkoutsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsRequest}
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupWorkoutsRequest;
  return proto.fitness.service.v1.GetGroupWorkoutsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsRequest}
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupWorkoutsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsRequest} returns this
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool active_only = 2;
 * @return {boolean}
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsRequest} returns this
 */
proto.fitness.service.v1.GetGroupWorkoutsRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupWorkoutsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutsList: jspb.Message.toObjectList(msg.getWorkoutsList(),
    proto.fitness.service.v1.GroupWorkout.toObject, includeInstance),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsResponse}
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupWorkoutsResponse;
  return proto.fitness.service.v1.GetGroupWorkoutsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsResponse}
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.GroupWorkout;
      reader.readMessage(value,proto.fitness.service.v1.GroupWorkout.deserializeBinaryFromReader);
      msg.addWorkouts(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupWorkoutsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupWorkoutsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.GroupWorkout.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated GroupWorkout workouts = 1;
 * @return {!Array<!proto.fitness.service.v1.GroupWorkout>}
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.getWorkoutsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.GroupWorkout>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.GroupWorkout, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.GroupWorkout>} value
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsResponse} returns this
*/
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.setWorkoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.GroupWorkout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.GroupWorkout}
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.addWorkouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.GroupWorkout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsResponse} returns this
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.clearWorkoutsList = function() {
  return this.setWorkoutsList([]);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupWorkoutsResponse} returns this
 */
proto.fitness.service.v1.GetGroupWorkoutsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupWorkoutId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.RemoveWorkoutFromGroupRequest;
  return proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupWorkoutId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_workout_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.prototype.getGroupWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.RemoveWorkoutFromGroupRequest} returns this
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupRequest.prototype.setGroupWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.RemoveWorkoutFromGroupResponse;
  return proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.RemoveWorkoutFromGroupResponse} returns this
 */
proto.fitness.service.v1.RemoveWorkoutFromGroupResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupWorkoutId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
dailyWorkoutsList: jspb.Message.toObjectList(msg.getDailyWorkoutsList(),
    fitness$service_v1_workout_pb.DailyWorkout.toObject, includeInstance),
goals: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
difficulty: jspb.Message.getFieldWithDefault(msg, 7, ""),
planType: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest;
  return proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupWorkoutId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = new fitness$service_v1_workout_pb.DailyWorkout;
      reader.readMessage(value,fitness$service_v1_workout_pb.DailyWorkout.deserializeBinaryFromReader);
      msg.addDailyWorkouts(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGoals(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDifficulty(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPlanType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDailyWorkoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      fitness$service_v1_workout_pb.DailyWorkout.serializeBinaryToWriter
    );
  }
  f = message.getGoals();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDifficulty();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPlanType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string group_workout_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getGroupWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setGroupWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated DailyWorkout daily_workouts = 4;
 * @return {!Array<!proto.fitness.service.v1.DailyWorkout>}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getDailyWorkoutsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.DailyWorkout>} */ (
    jspb.Message.getRepeatedWrapperField(this, fitness$service_v1_workout_pb.DailyWorkout, 4));
};


/**
 * @param {!Array<!proto.fitness.service.v1.DailyWorkout>} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setDailyWorkoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.fitness.service.v1.DailyWorkout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.DailyWorkout}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.addDailyWorkouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.fitness.service.v1.DailyWorkout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.clearDailyWorkoutsList = function() {
  return this.setDailyWorkoutsList([]);
};


/**
 * optional string goals = 5;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getGoals = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setGoals = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string difficulty = 7;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getDifficulty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string plan_type = 8;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.getPlanType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanRequest.prototype.setPlanType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
groupWorkout: (f = msg.getGroupWorkout()) && proto.fitness.service.v1.GroupWorkout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse;
  return proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.GroupWorkout;
      reader.readMessage(value,proto.fitness.service.v1.GroupWorkout.deserializeBinaryFromReader);
      msg.setGroupWorkout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupWorkout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fitness.service.v1.GroupWorkout.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GroupWorkout group_workout = 2;
 * @return {?proto.fitness.service.v1.GroupWorkout}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.getGroupWorkout = function() {
  return /** @type{?proto.fitness.service.v1.GroupWorkout} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.GroupWorkout, 2));
};


/**
 * @param {?proto.fitness.service.v1.GroupWorkout|undefined} value
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse} returns this
*/
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.setGroupWorkout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.clearGroupWorkout = function() {
  return this.setGroupWorkout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateGroupWorkoutPlanResponse.prototype.hasGroupWorkout = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupWorkoutId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest;
  return proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupWorkoutId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_workout_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.prototype.getGroupWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanRequest.prototype.setGroupWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse;
  return proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.DeleteGroupWorkoutPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupMembershipHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupMembershipHistoryRequest;
  return proto.fitness.service.v1.GetGroupMembershipHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupMembershipHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} returns this
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryRequest} returns this
 */
proto.fitness.service.v1.GetGroupMembershipHistoryRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupMembershipHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
membershipRecordsList: jspb.Message.toObjectList(msg.getMembershipRecordsList(),
    proto.fitness.service.v1.GroupMembershipRecord.toObject, includeInstance),
totalJoins: jspb.Message.getFieldWithDefault(msg, 2, 0),
currentlyActive: jspb.Message.getFieldWithDefault(msg, 3, 0),
message: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupMembershipHistoryResponse;
  return proto.fitness.service.v1.GetGroupMembershipHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.GroupMembershipRecord;
      reader.readMessage(value,proto.fitness.service.v1.GroupMembershipRecord.deserializeBinaryFromReader);
      msg.addMembershipRecords(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalJoins(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentlyActive(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupMembershipHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipRecordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.GroupMembershipRecord.serializeBinaryToWriter
    );
  }
  f = message.getTotalJoins();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCurrentlyActive();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated GroupMembershipRecord membership_records = 1;
 * @return {!Array<!proto.fitness.service.v1.GroupMembershipRecord>}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.getMembershipRecordsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.GroupMembershipRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.GroupMembershipRecord, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.GroupMembershipRecord>} value
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} returns this
*/
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.setMembershipRecordsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.GroupMembershipRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.GroupMembershipRecord}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.addMembershipRecords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.GroupMembershipRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} returns this
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.clearMembershipRecordsList = function() {
  return this.setMembershipRecordsList([]);
};


/**
 * optional int32 total_joins = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.getTotalJoins = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} returns this
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.setTotalJoins = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 currently_active = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.getCurrentlyActive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} returns this
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.setCurrentlyActive = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupMembershipHistoryResponse} returns this
 */
proto.fitness.service.v1.GetGroupMembershipHistoryResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GroupMembershipRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GroupMembershipRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GroupMembershipRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
client: (f = msg.getClient()) && fitness$service_v1_common_pb.ClientProfile.toObject(includeInstance, f),
joinDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
leaveDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
notes: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GroupMembershipRecord}
 */
proto.fitness.service.v1.GroupMembershipRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GroupMembershipRecord;
  return proto.fitness.service.v1.GroupMembershipRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GroupMembershipRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GroupMembershipRecord}
 */
proto.fitness.service.v1.GroupMembershipRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 3:
      var value = new fitness$service_v1_common_pb.ClientProfile;
      reader.readMessage(value,fitness$service_v1_common_pb.ClientProfile.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setJoinDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLeaveDate(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GroupMembershipRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GroupMembershipRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GroupMembershipRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fitness$service_v1_common_pb.ClientProfile.serializeBinaryToWriter
    );
  }
  f = message.getJoinDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLeaveDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ClientProfile client = 3;
 * @return {?proto.fitness.service.v1.ClientProfile}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.getClient = function() {
  return /** @type{?proto.fitness.service.v1.ClientProfile} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_common_pb.ClientProfile, 3));
};


/**
 * @param {?proto.fitness.service.v1.ClientProfile|undefined} value
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
*/
proto.fitness.service.v1.GroupMembershipRecord.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.hasClient = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string join_date = 4;
 * @return {string}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.getJoinDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.setJoinDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string leave_date = 5;
 * @return {string}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.getLeaveDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.setLeaveDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_active = 6;
 * @return {boolean}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GroupMembershipRecord} returns this
 */
proto.fitness.service.v1.GroupMembershipRecord.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


goog.object.extend(exports, proto.fitness.service.v1);
